import {$, $$, hide, toggle, getParentElementByTagName, scrolltoElement} from "../../core/js/Dom.ts";
import {$get} from "../../core/js/Ajax.ts";
import {fadeOutFadeIn} from "../../core/js/Animate.ts";
import {createDataTables} from "../../core/js/DataTables.ts";

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.url === "tableau-de-bord-organisateur") {
        initListeners()
        initTable("#liste-circuits", '#liste-circuits-container', false)
    }
})

async function initTable(tableSelecteur: string, parentSelecteur: string = "#tdb-list-onglet-mes-dossiers-tab", search: boolean = true) {
    const parent = $(parentSelecteur)
    const table = $(tableSelecteur)
    if (table && parent) {
        await createDataTables(table, {
            "paging": false,
            "info": false,
            searching: false
        })
        $$('.dataTables_filter', parent).forEach(element => hide(element))

        if (search) {
            function handleFiltre(event: DOMEvent<HTMLInputElement>) {
                const value = event.target.value.toLowerCase();
                // @ts-ignore
                $$("tbody tr", table).forEach((row) => {
                    toggle(row, row.innerText.toLowerCase().indexOf(value) > -1)
                })
            }

            $("#search", parent)?.addEventListener('input', handleFiltre)
        }

        $$('tr.clickligne', table).forEach(row => {
            row.addEventListener('click', clickOnRow)
            row.addEventListener('keyup', clickOnRow)
        })
    }
}

function clickOnRow(event: DOMEvent<HTMLElement>) {
    if ((event.type === "keyup" && (event.code === "Enter" || event.code === "NumpadEnter")) || event.type === "click") {
        const row = getParentElementByTagName(event.target, 'tr')
        const url = row?.dataset.href
        if (row && url) {
            if (!window.Openscop.TESTS_IN_PROGRESS) {
                // @ts-ignore
                window.open(url, '_blank').focus();
            } else {
                // @ts-ignore
                window.location = url;
            }
        }
    }
}

function initListeners() {
    $$('.btn_etat_1').forEach(element => element?.addEventListener('click', loadDossierList))
    $$('.btn_etat_2').forEach(element => element?.addEventListener('click', loadDossierList))
    $('#annee')?.addEventListener('change', refreshArchiveList)
    $('.btn_consult')?.addEventListener('click', showDossierEnconsultation);
}

async function loadDossierList(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const target = getParentElementByTagName(event.target, 'a')
    let url_type = window.Openscop.url_tableau_organisateur_liste
    const query = new URLSearchParams(location.search)
    const list = $('#block_tableaubord_liste')
    const loadingIndicateur = $('#tdb-loading-list')

    if (target && list && loadingIndicateur) {
        let btn_etat = target.id
        query.set('filtre_etat', btn_etat.split('_')[2])
        await fadeOutFadeIn(list, loadingIndicateur)

        $get(url_type, query).then(async (response) => {
            list.setAttribute('tabindex', '0')
            list.innerHTML = response.body
            await initTable("#manif-table")
            fadeOutFadeIn(loadingIndicateur, list)
            scrolltoElement(list)
        })
    }
}

async function refreshArchiveList(event: DOMEvent<HTMLSelectElement>) {
    event.preventDefault()
    const target = event.target
    let annee = target.value
    let parametres = new URLSearchParams(window.location.search)
    const list = $('#block_tableaubord_liste_archive')
    const loadingIndicateur = $('#tdb-loading-archive')

    if (list && loadingIndicateur) {
        if (annee !== "") {
            await fadeOutFadeIn(list, loadingIndicateur)
            parametres.set('annee', annee)

            const url_list_tableau_organisateur = window.Openscop.url_tableau_organisateur_liste
            $get(url_list_tableau_organisateur, parametres).then(async (response) => {
                list.innerHTML = response.body
                await initTable("#manif-table", "#block_tableaubord_liste_archive")
                fadeOutFadeIn(loadingIndicateur, list)
                scrolltoElement(list)
            })
        }
    }
}

async function showDossierEnconsultation(event: DOMEvent<HTMLElement>) {
    event.preventDefault();
    const loadingIndicateur = $('#tdb-loading-list')
    const list = $('#block_tableaubord_consult')
    await fadeOutFadeIn(list, loadingIndicateur)

    if (list && loadingIndicateur) {
        let parametres = new URLSearchParams(window.location.search)
        let url_complete = window.Openscop.url_consultation_liste
        $get(url_complete, parametres).then(async (response) => {
            list.innerHTML = response.body
            await initTable("#manif-table-consultation", '#tdb-list-onglet-consultation-tab')
            fadeOutFadeIn(loadingIndicateur, list)
            scrolltoElement(list)
        });
    }
}